import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/AWS-Developer-Associate-2020.png'


const _withScopeId = n => (_pushScopeId("data-v-1f079714"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  class: "columns is-column-mobile is-flex is-flex-wrap-wrap"
}
const _hoisted_2 = { class: "column is-3" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "column is-flex is-flex-direction-column has-text-right is-align-items-flex-end" }
const _hoisted_6 = { class: "is-size-1 is-size-2-mobile" }
const _hoisted_7 = { class: "mb-4 is-size-4 is-size-5-mobile has-text-grey-light" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Stack Overflow Reputation: ")
const _hoisted_9 = { href: "https://stackoverflow.com/users/1147618/dbramwell" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mb-4 is-size-4 is-size-5-mobile" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "./david_bramler_cv.pdf" }, "Download CV")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-size-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://stackoverflow.com/users/1147618/dbramwell" }, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"color":"hsl(27,90%,55%)"},
      class: "mr-3 fab fa-stack-overflow"
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/david-bramler-423b2136/" }, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"color":"#0a66c2"},
      class: "mr-3 fab fa-linkedin"
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/dbramwell" }, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"color":"#000000"},
      class: "fab fa-github-square"
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-justify-content-flex-start" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.credly.com/badges/bb4735ce-1d2d-4a57-a58c-8993e4b81f9a/public_url" }, [
    /*#__PURE__*/_createElementVNode("figure", { class: "image is-128x128" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ])
  ])
], -1))
const _hoisted_13 = { class: "is-size-3 is-size-4-mobile" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("figure", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.avatarUrl,
            class: "is-rounded"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.name), 1),
        _createElementVNode("h6", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.stackoverflowRep), 1)
        ]),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12
      ])
    ]),
    _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.summary), 1),
    _hoisted_14
  ]))
}